import type { ParseDeveloperOrganizationIdsFromClaimsParams } from '../types';

const DEVELOPER_ORGANIZATION_ROLE = 'developer';
const DANGEROUS_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

/**
 * Mirrors services/auth/principal parseDeveloperOrganizationIds for browser claims.
 */
const parseDeveloperOrganizationIdsFromClaims = ({
    organizationsClaim,
}: ParseDeveloperOrganizationIdsFromClaimsParams): string[] => {
    if (
        organizationsClaim === null ||
        typeof organizationsClaim !== 'object' ||
        Array.isArray(organizationsClaim)
    ) {
        return [];
    }

    const organizationIds: string[] = [];

    for (const [organizationId, role] of Object.entries(organizationsClaim)) {
        if (DANGEROUS_KEYS.has(organizationId)) {
            continue;
        }
        if (organizationId.length === 0) {
            continue;
        }
        if (role !== DEVELOPER_ORGANIZATION_ROLE) {
            continue;
        }
        organizationIds.push(organizationId);
    }

    return organizationIds;
};

export default parseDeveloperOrganizationIdsFromClaims;
